import { defineComponent as _defineComponent } from 'vue'
import { DEFAULT_PER_PAGE, IPaginateEventParams } from "@/shared";
import { computed, ref, watch } from "vue";

// props
interface IProps {
	count: number;
}
interface IEmit {
	(e: "paginate", params: IPaginateEventParams): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    count: null
  },
  emits: ["paginate"],
  setup(__props: any, { emit }: { emit: ({
	(e: "paginate", params: IPaginateEventParams): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	count: number;
};



// computed
const disablePrevButton = computed<boolean>(() => {
	return page.value === 0;
});
const disableNextButton = computed<boolean>(() => {
	const { end } = getStartAndEndIndex.value;

	return end >= props.count;
});
const getTotalPages = computed<number>(() => {
	if (props.count === 0) return 1;
	return Math.ceil(props.count / perPage.value);
});
const getStartAndEndIndex = computed(() => {
	let end = page.value * perPage.value;
	const start = end - perPage.value;

	if (end > props.count) {
		end = props.count;
	}

	return { start, end };
});

// data
const page = ref<number>(0);
const perPage = ref<number>(DEFAULT_PER_PAGE);

// methods
function prev(): void {
	page.value--;
}
function next(): void {
	page.value++;
}
function setPage(): void {
	if (page.value > getTotalPages.value) {
		page.value = getTotalPages.value;
	}
	if (page.value < 0) {
		page.value = 0;
	}
}
function reset(): void {
	page.value = 0;
}

// watch
watch(
	() => getStartAndEndIndex.value,
	() => {
		if (page.value > getTotalPages.value) return;

		const { start: startIndex, end: endIndex } = getStartAndEndIndex.value;
		emit("paginate", {
			page: page.value,
			perPage: perPage.value,
			startIndex,
			endIndex,
		});
	}
);

// emits



return { __sfc: true,props, disablePrevButton, disableNextButton, getTotalPages, getStartAndEndIndex, page, perPage, prev, next, setPage, reset, emit }
}

})